module.exports = __webpack_public_path__ + "static/loading.cb505bf9ab3f2d612ed49e94d757c3cc.svg";